import {DEFAULT_PAGE_SIZE} from 'app/utils/constants';

export {showMessages} from './feedback-messages';
export {showLoadingBar} from './loading-bar';
export {
  handleAccountLimitErrors,
  UPGRADE_MODALS,
} from './handle-account-limit-errors';
export {
  createTagsListFromResponse,
  providesTagsByURL,
  tagsRelatedTo,
} from './rtk-tags';
export {
  createListHookReadingFromById,
  createDetailHookReadingFromById,
  createGenericHookReadingFromById,
} from './read-hook-byid';

interface Location {
  page?: string;
  page_size?: string;
}

type Fetch<T> = Omit<T, 'page' | 'page_size'> & {
  page: string;
  page_size: string;
};

export const convertLocationParamsToFetchParams = <T extends Location>(
  query: T
): Fetch<T> => ({
  ...query,
  page: query.page != null ? query.page : '1',
  page_size: query.page_size != null ? query.page_size : DEFAULT_PAGE_SIZE,
});

export type LocationWithoutPageParams<T> = Omit<T, 'page' | 'page_size'> & {
  page: undefined;
  page_size: undefined;
};

export type InverseLocation<T> = Omit<T, 'page' | 'page_size'> & {
  page?: string;
  page_size?: string;
};

export type InverseFetch = {
  page: string;
  page_size: string;
};

export const revertLocationParamsConvertion = <T extends InverseFetch>(
  query: T
): InverseLocation<T> => ({
  ...query,
  page: query.page == '1' ? undefined : query.page,
  page_size:
    query.page_size == DEFAULT_PAGE_SIZE.toString()
      ? undefined
      : query.page_size,
});

export const removePageParams = <T extends InverseFetch>(
  query: T
): LocationWithoutPageParams<T> => ({
  ...query,
  page: undefined,
  page_size: undefined,
});
